import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12de78e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TariffFtl" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-400" }, "Загрузка тарифа...", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-red-400" }, "Произошла ошибка при загрузке тарифа", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "TariffFtl__header" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = {
  key: 0,
  class: "fas fa-check text-green-500 ml-2"
}
const _hoisted_9 = {
  key: 1,
  class: "fas fa-times text-red-500 ml-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "TariffFtl__body"
}
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"TariffFtl__grid\" data-v-12de78e6><span data-v-12de78e6></span><span class=\"font-semibold text-sm text-center\" data-v-12de78e6>Грузоподъемность авто</span><span class=\"font-semibold text-sm text-center\" data-v-12de78e6>Зона</span><span class=\"font-semibold text-sm text-center\" data-v-12de78e6>Минималка (часы)</span><span class=\"font-semibold text-sm text-center\" data-v-12de78e6>Тариф за минималку(тг)</span><span class=\"font-semibold text-sm text-center\" data-v-12de78e6>Тариф за +1 доп час (тг)</span></div>", 1)
const _hoisted_13 = { class: "flex items-center font-semibold" }
const _hoisted_14 = { class: "flex items-center justify-center text-center" }
const _hoisted_15 = { class: "flex items-center justify-center text-center" }
const _hoisted_16 = { class: "flex items-center justify-center text-center" }
const _hoisted_17 = { class: "flex items-center justify-center text-center" }
const _hoisted_18 = { class: "flex items-center justify-center text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_page_title = _resolveComponent("page-title")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.state.is_loading || _ctx.state.is_failed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.state.is_loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_3,
                _createVNode(_component_loader, { class: "primary mt-1" })
              ], 64))
            : (_ctx.state.is_failed)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_4,
                  _createVNode(_component_the_button, {
                    class: "primary small mt-2",
                    onClick: _ctx.loadFtlTariff
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Перезагрузить ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_page_title, {
                title: `FTL тариф ${_ctx.getCompanyName}`
              }, null, 8, ["title"]),
              (_ctx.isVatEnabled)
                ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                : (_ctx.isVatDisabled)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_9))
                  : _createCommentVNode("", true)
            ]),
            _createVNode(_component_the_button, {
              class: "second small text",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(" Назад ")
              ]),
              _: 1
            })
          ]),
          (_ctx.state.tariffs)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.tariffs, (tariff, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `tariff-ftl-${i}`,
                    class: "TariffFtl__grid mt-3"
                  }, [
                    _createElementVNode("div", _hoisted_13, "Тариф №" + _toDisplayString(i + 1), 1),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(tariff.volume), 1),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(tariff.zone.description), 1),
                    _createElementVNode("div", _hoisted_16, _toDisplayString(tariff.minimumHour), 1),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(tariff.price), 1),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(tariff.cost), 1)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}